// 通用js方法封装处理
// 允许不校验驼峰格式参数名，可以使用ab_cd这种形式
/* eslint-disable camelcase */

// 解析路由列表去适配数据
import {showToast} from 'vant'
import {getDictDataReq} from '@/api/hwgk_api.js'

// 返回项目路径
export function getNormalPath (p) {
  if (p.length === 0 || !p || p === 'undefined') {
    return p
  }
  const res = p.replace('//', '/')
  if (res[res.length - 1] === '/') {
    return res.slice(0, res.length - 1)
  }
  return res
}

export const getRouteComponentId = (id) => `frame_${id}`

// 验证是否为blob格式
export async function blobValidate (data) {
  try {
    const text = await data.text()
    JSON.parse(text)
    return false
  } catch (error) {
    return true
  }
}


/**
 * 防抖
 * @param fn 执行函数
 * @param ms 间隔毫秒数
 */
export const debounce = (fn, ms) => {
  return (...args) => {
    if (window.lazy) {
      clearTimeout(window.lazy)
    }
    window.lazy = setTimeout(() => {
      fn(...args)
    }, ms)
  }
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export const tansParams = (params) => {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    const part = encodeURIComponent(propName) + '='
    if (value !== null && value !== '' && typeof (value) !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof (value[key]) !== 'undefined') {
            const params = propName + '[' + key + ']'
            const subPart = encodeURIComponent(params) + '='
            result += subPart + encodeURIComponent(value[key]) + '&'
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&'
      }
    }
  }
  return result
}
const modules = import.meta.glob('../views/**/*.vue')
export const getVuePathComponent = (p) => {
  for (const path in modules) {
    const dir = path.split('views')[1].split('.vue')[0]
    if (dir === p) {
      return () => modules[path]()
    }
  }
  // return res;
  return () => import('../views/error/404.vue')
}

// 表单重置
export const resetForm = (refName) => {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields()
  }
}

// 日期格式化
export const parseTime = (time, pattern) => {
  if (!time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace((/-/gm), '/').replace('T', ' ').replace((/\.[\d]{3}/gm), '')
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
// 添加日期范围
export const addDateRange = (params, dateRange, propName) => {
  const search = params
  search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {}
  dateRange = Array.isArray(dateRange) ? dateRange : []
  if (typeof (propName) === 'undefined') {
    search.params.beginTime = dateRange[0]
    search.params.endTime = dateRange[1]
  } else {
    search.params['begin' + propName] = dateRange[0]
    search.params['end' + propName] = dateRange[1]
  }
  return search
}

// 获取图片getAssetsFile
export const getAssetsFile = (url) => {
  return  new URL(`../assets/images/${url}`, import.meta.url).href
}
export const getImgByUrl = (url) => {
  return new URL(`../assets/images/site/home/${url}`, import.meta.url).href
}

export const showToastU = (str) => {
  showToast({
    message: str,
    className: 'particulars-detail-popup'
  })

}

export const getDictData = async (type) => {
  const res = await getDictDataReq({types: [type]})
  if (res.code === 1) {
    return res.result[type]
  } else {
    return []
  }
}
